/**
 * Tone definitions shared across all content-generation pages.
 *
 * TONES            — full list of selectable tones (id, label, emoji, description)
 * DEFAULT_TONE_BY_CONTENT_TYPE — maps each PromptRegistry contentType key to its
 *                    sensible default tone. Consumed by <ToneSelector> so pages
 *                    never need to hardcode a default themselves.
 */

export const TONES = [
  { id: 'authoritative',  label: 'Authoritative',    emoji: '📢', description: 'Firm, credible, commanding — standard news delivery' },
  { id: 'urgent',         label: 'Urgent',           emoji: '🚨', description: 'Breaking news urgency, fast-paced' },
  { id: 'empathetic',     label: 'Empathetic',       emoji: '💙', description: 'Human-interest, compassionate delivery' },
  { id: 'analytical',     label: 'Analytical',       emoji: '🔍', description: 'Data-driven, investigative, measured' },
  { id: 'optimistic',     label: 'Optimistic',       emoji: '🌟', description: 'Uplifting, positive, community-focused' },
  { id: 'critical',       label: 'Critical',         emoji: '⚡', description: 'Questioning, challenging, accountability journalism' },
  { id: 'satirical',      label: 'Satirical / Wit',  emoji: '😏', description: 'Irony, wit, light commentary' },
  { id: 'celebratory',    label: 'Celebratory',      emoji: '🎉', description: 'Festive, joyful, cultural occasion tone' },
  { id: 'somber',         label: 'Somber',           emoji: '🕯️', description: 'Grief, tragedy, respectful solemnity' },
  { id: 'conversational', label: 'Conversational',   emoji: '💬', description: 'Casual, engaging, talk-show style' },
];

export const DEFAULT_TONE_BY_CONTENT_TYPE = {
  // Anchor formats
  anchorVisual:          'authoritative',
  anchorVisualByte:      'authoritative',
  anchorByte:            'authoritative',
  anchorPackage:         'authoritative',
  anchorLive:            'urgent',
  anchorToReporter:      'authoritative',
  anchorToGuest:         'conversational',
  anchorDrive:           'authoritative',
  // Breaking & Tops
  tops:                  'authoritative',
  breakingPoints:        'urgent',
  breakingPlates:        'urgent',
  breakingNewsPresentation: 'urgent',
  // Bulletin & formats
  newsBulletin:          'authoritative',
  headlinesSlugs:        'authoritative',
  scrollings:            'urgent',
  anchorBgTitles:        'authoritative',
  voiceOver:             'authoritative',
  speedNews:             'urgent',
  // Script modes — tone follows the mode itself, default to authoritative
  scriptModeTelangana:   'conversational',
  scriptModeIrony:       'satirical',
  scriptModeUplifting:   'optimistic',
  scriptModeCritical:    'critical',
  scriptModeBalanced:    'analytical',
  // Social
  socialMediaAll:        'conversational',
  socialMediaYouTube:    'optimistic',
  socialMediaFacebook:   'conversational',
  socialMediaInstagram:  'celebratory',
  socialMediaTwitter:    'urgent',
  // Programs
  burningIssue:          'critical',
  tcr:                   'critical',
  worldNews:             'critical',
  crimeStory:            'critical',
  // Long formats
  indepth30:             'analytical',
  offTheRecord30:        'conversational',
  specialFocus30:        'analytical',
  analysis10:            'analytical',
  promoScript:           'urgent',
  // Speciality
  sportsMatchReview:     'celebratory',
  sportsPanelDiscussion: 'analytical',
  interviewDoctor:       'empathetic',
  interviewEducation:    'optimistic',
  interviewRealEstate:   'conversational',
  videoToScript:         'authoritative',
  conspiracyTheory:      'critical',
};
